module.exports = __webpack_public_path__ + "img/Antique Oak.a0ab2954.jpg";